import { useState, useCallback } from 'react';
import type { Payment } from '../types';
import { useMarkPaid } from './use-mark-paid';

// Fase: dropping a card on "Pagado" pays it directly when it meets the
// minimum. Below-minimum-but-payable cards instead open a confirmation
// modal; the card stays optimistically in "Pagado" while `confirming` is
// set, and only commits on confirm (or reverts on cancel).
export function usePaidConfirm() {
  const markPaid = useMarkPaid();
  const [confirming, setConfirming] = useState<Payment | null>(null);

  const onDrop = useCallback(
    (p: Payment) => {
      if (p.meets_minimum) markPaid.mutate(p.id);
      else setConfirming(p);
    },
    [markPaid]
  );

  const onConfirm = useCallback(() => {
    if (!confirming) return;
    markPaid.mutate(confirming.id, { onSettled: () => setConfirming(null) });
  }, [confirming, markPaid]);

  const onCancel = useCallback(() => setConfirming(null), []);

  return {
    confirming,
    onDrop,
    onConfirm,
    onCancel,
    isPending: markPaid.isPending,
  };
}
